// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.8);
}

.overlay-content {
  position: absolute;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  top: 50%;
  left: 0;
  right: 0;
  text-align: center;
  color: #555;
}

:host ::ng-deep .ui-inputnumber-input {
  width: 100% !important;
}
:host ::ng-deep .ui-inputnumber-input .ui-button {
  background-color: #337ab7;
}
:host ::ng-deep .p-datatable.chevron-table .flex-column {
  flex-direction: column;
}
:host ::ng-deep .p-datatable.chevron-table .flex-end {
  justify-content: flex-end;
}
:host ::ng-deep .p-datatable.chevron-table .ui-table-wrapper {
  overflow: visible;
}
:host ::ng-deep .p-datatable.chevron-table table {
  border-collapse: separate;
  border-spacing: 0 0px;
  width: 100% !important;
}
:host ::ng-deep .p-datatable.chevron-table table thead {
  font-size: 12px;
  font-weight: bold;
  background-color: transparent;
}
:host ::ng-deep .p-datatable.chevron-table table thead th {
  padding: none !important;
  background-color: transparent;
  border: none;
}
:host ::ng-deep .p-datatable.chevron-table table thead th.bg-highlight {
  background-color: #e5f8ff;
  height: 50px;
}
:host ::ng-deep .p-datatable.chevron-table table thead th.subtitle {
  text-transform: none !important;
  font-size: 18px;
  font-weight: bold;
}
:host ::ng-deep .p-datatable.chevron-table table thead th.info {
  font-weight: 100;
}
:host ::ng-deep .p-datatable.chevron-table table thead .ui-sortable-column.ui-state-highlight {
  background-color: transparent;
  color: #0066b2 !important;
  font-weight: bolder;
}
:host ::ng-deep .p-datatable.chevron-table table thead .ui-sortable-column.ui-state-highlight:focus {
  box-shadow: none !important;
}
:host ::ng-deep .p-datatable.chevron-table table thead .pi {
  font-size: 1em;
  padding-left: 5px;
}
:host ::ng-deep .p-datatable.chevron-table table thead .pi-sort-amount-down:before {
  color: #0066b2;
}
:host ::ng-deep .p-datatable.chevron-table table thead .pi-sort-amount-up-alt:before {
  color: #0066b2;
}
:host ::ng-deep .p-datatable.chevron-table table tbody {
  border-spacing: 0 0px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr {
  background-color: #fff;
  color: #8c8f93;
  font-size: 13px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr.selected {
  background-color: #e7f9ff;
  font-weight: 700 !important;
  font-size: 14px !important;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr:hover {
  background-color: #f8f8f8;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td {
  border: 0px solid #dbdcdd;
  border-bottom-width: 1px;
  padding: 10px 10px;
  vertical-align: middle;
  height: 60px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td.no-data-found {
  padding: 35px 0px;
  border: dotted 2px #0066b2 !important;
  background-color: rgba(0, 102, 178, 0.05);
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td.no-data-found .row {
  text-align: center;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td.no-data-found .title {
  background-color: transparent !important;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td.no-data-found .icon-sm {
  height: 40px;
  width: auto;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td:first-child td:first-child {
  border-top-left-radius: 6px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td:first-child td:last-child {
  border-top-right-radius: 6px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td:last-child td:first-child {
  border-bottom-left-radius: 6px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td:last-child td:last-child {
  border-bottom-right-radius: 6px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td.separator {
  border: none;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td p {
  font-weight: 100;
  margin-bottom: 0px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td p.rounded {
  display: flex;
  border: 1px solid #dbdcdd;
  border-radius: 6px;
  padding: 0 10px;
  max-width: 150px;
  float: left;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td p span {
  color: black;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td .larger {
  font-size: 14px;
  font-weight: bolder !important;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td .small {
  font-size: 10px;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td .ui-inputtext {
  width: 100% !important;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td .ui-inputtext.ui-autocomplete-input {
  width: 80% !important;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td .ui-inputnumber {
  width: 100% !important;
}
:host ::ng-deep .p-datatable.chevron-table table tbody tr td .ui-inputnumber .ui-button {
  background-color: #337ab7;
}
:host ::ng-deep .p-datatable.chevron-table table .highlight {
  color: #0066b2 !important;
}
:host ::ng-deep .p-datatable.chevron-table table .bg-shadow {
  background-color: #fafafa;
}
:host ::ng-deep .p-datatable.chevron-table table .link {
  cursor: pointer;
}
:host ::ng-deep .p-datatable.chevron-table table ::ng-deep .ui-radiobutton .ui-radiobutton-box .ui-radiobutton-icon {
  top: 2px !important;
  left: 3px !important;
}
:host ::ng-deep .p-datatable.chevron-table table .ui-autocomplete-dd .ui-autocomplete-dropdown.ui-corner-all {
  height: 28px;
}
:host ::ng-deep .p-datatable.chevron-table.no-spacing table {
  border-collapse: collapse !important;
}
:host ::ng-deep .p-datatable.chevron-table .ui-paginator {
  background-color: transparent;
  text-align: right;
  border: none;
}
:host ::ng-deep .p-datatable.chevron-table .ui-paginator .ui-paginator-pages a {
  background-color: transparent;
  color: #0066b2;
}
:host ::ng-deep .p-datatable.chevron-table .ui-paginator .ui-paginator-pages a.ui-state-active {
  font-weight: bold;
  border-bottom: solid 2px #0066b2;
}
:host ::ng-deep .p-datatable.chevron-table .ui-paginator .ui-paginator-pages a:active {
  background-color: transparent;
}
:host ::ng-deep .content .page {
  padding: 0;
  margin: 0;
  background-color: #f7f7f8;
}
:host ::ng-deep .content .page .row.form,
:host ::ng-deep .content .page .row.list {
  padding: 20px;
}
:host ::ng-deep .content .page .row.form .filters,
:host ::ng-deep .content .page .row.list .filters {
  display: inline-flex;
}
:host ::ng-deep .content .page .row.card {
  box-shadow: 0 4px 8px 0 rgba(178, 180, 179, 0.16);
  padding: 10px;
  background-color: white;
  min-height: 0px;
  margin: 0;
}
:host ::ng-deep .content .page .row.card .title {
  text-transform: lowercase;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
:host ::ng-deep .content .page .form .d-flex {
  display: flex;
}
:host ::ng-deep .content .page .form .form-control {
  border-color: #a2a2a2;
  color: #0066b2;
  font-weight: 500;
  border-radius: 0;
}
:host ::ng-deep .content .page .form .form-control::placeholder {
  color: rgba(0, 101, 178, 0.6117647059);
}
:host ::ng-deep .content .page .form label span {
  font-weight: 100;
  color: #8c8f93;
}
:host ::ng-deep .content .page .btn {
  border-radius: 0 !important;
  outline: none !important;
}
:host ::ng-deep .content .page .btn:disabled {
  color: #6b6d6f;
  background-color: #dbdcdd;
  border-color: #dbdcdd;
}
:host ::ng-deep .p-paginator {
  justify-content: flex-end !important;
  font-size: 12px !important;
  background-color: transparent !important;
}
:host ::ng-deep .p-tabview-nav {
  display: flex;
  place-content: center;
}
:host ::ng-deep .p-tabview-nav li {
  background-color: transparent !important;
  border: none !important;
}
:host ::ng-deep .p-tabview-nav li:focus {
  box-shadow: none !important;
}
:host ::ng-deep .p-tabview-nav li a {
  text-align: center;
  justify-content: center;
  color: #0066b2 !important;
  font-size: 16px;
  font-family: "GothamBook";
  line-height: 25px;
  padding: 15px 25px !important;
}
:host ::ng-deep .p-tabview-nav li.ui-state-active {
  border-bottom: 3px solid #142d73 !important;
  transition: border-width 0.6s linear;
}
:host ::ng-deep .p-tabview-nav li.ui-state-active a {
  color: #142d73 !important;
}
:host ::ng-deep .ui-tabview-panels {
  border: none !important;
}
:host ::ng-deep .p-component {
  font-family: inherit;
  font-size: inherit;
}
:host ::ng-deep .p-inputtext {
  font-family: inherit;
  font-size: inherit;
}
:host ::ng-deep .alert {
  padding: 5px 10px;
  margin-bottom: 0px;
  height: 32px;
  min-height: 32px;
}
:host ::ng-deep .alert-danger {
  color: #d05351;
}
:host ::ng-deep .cvx-toast .ui-toast-icon {
  top: 30%;
}
:host ::ng-deep .cvx-toast .ui-toast-icon.pi {
  font-size: 1.7em;
}
:host ::ng-deep .cvx-toast .ui-toast-message {
  background-color: white !important;
  color: grey;
}
:host ::ng-deep .cvx-toast .ui-toast-message.ui-toast-message-success {
  border-left: 10px solid #74b574;
}
:host ::ng-deep .cvx-toast .ui-toast-message.ui-toast-message-success .ui-toast-summary {
  color: #74b574;
}
:host ::ng-deep .cvx-toast .ui-toast-message.ui-toast-message-success .ui-toast-icon {
  color: #74b574;
}
:host ::ng-deep .cvx-toast .ui-toast-message.ui-toast-message-error {
  border-left: 10px solid #c74f4f;
}
:host ::ng-deep .cvx-toast .ui-toast-message.ui-toast-message-error .ui-toast-summary {
  color: #c74f4f;
}
:host ::ng-deep .cvx-toast .ui-toast-message.ui-toast-message-error .ui-toast-icon {
  color: #c74f4f;
}

app-help-tutorials {
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: visible;
  z-index: 9998;
}

::ng-deep .help-tutorial-dialog-mask {
  z-index: 20000 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
